module.exports = __webpack_public_path__ + "static/media/pie alt.7acb5645.png";